import { createSlice } from "@reduxjs/toolkit";
import {
  createBillingCycle,
  fetchBillingCycle,
  fetchBillingCycles,
  generateBillingCycles,
} from "state/action/billing";

const billingCycleSlice = createSlice({
  name: "billingCycle",
  initialState: {
    cycles: [],
    selectedCycle: {},
    currentCycle: null,
    loading: false,
    error: null,
    metadata: null,
  },
  reducers: {
    clearCurrentCycle: (state) => {
      state.currentCycle = null;
    },
    setSelectedCycle: (state, action) => ({
      ...state,
      selectedCycle: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchBillingCycles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBillingCycles.fulfilled, (state, action) => {
        state.loading = false;
        state.cycles = action.payload.data;
        state.metadata = action.payload.metadata;
      })
      .addCase(fetchBillingCycles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch one
      .addCase(fetchBillingCycle.fulfilled, (state, action) => {
        state.currentCycle = action.payload.data;
      })
      // Create
      .addCase(createBillingCycle.fulfilled, (state, action) => {
        state.cycles.unshift(action.payload.data);
      })
      // Generate
      .addCase(generateBillingCycles.fulfilled, (state, action) => {
        state.cycles = [...action.payload.data, ...state.cycles];
      });
  },
});

export const billingCycleAction = {
  ...billingCycleSlice.actions,
  createBillingCycle,
  fetchBillingCycle,
  generateBillingCycles,
  fetchBillingCycles,
};

export function selectBillingCycles(state) {
  return state?.billingCycle;
}

export const { clearCurrentCycle } = billingCycleSlice.actions;
export default billingCycleSlice.reducer;
